import React from 'react';

const className = 'c-ProgressRing';

const ProgressRing = (props) => {
  const {
    progress,
    width = 20,
    height = 20,
    thickness = 10,
    progressColor = '#30A66D',
    progressBgColor = '#EBFAF0'
  } = props;

  const progressInDeg = 360 * (progress / 100);

  const containerDiskStyle = {
    width: `${width}px`,
    height: `${height}px`,
    position: 'relative',
    borderRadius: '100%',
    background: `conic-gradient(
        ${progressColor} ${progressInDeg}deg,
        ${progressBgColor} 0
    )`
  };

  const innerDiskDiameter = width - thickness;
  const innerDiskStyle = {
    width: `${innerDiskDiameter}px`,
    height: `${innerDiskDiameter}px`,
    position: 'absolute',
    borderRadius: '100%',
    background: 'white',
    top: `calc(50% - ${innerDiskDiameter / 2}px)`,
    left: `calc(50% - ${innerDiskDiameter / 2}px)`
  };

  return (
    <div className={className} style={containerDiskStyle}>
      <div style={innerDiskStyle}></div>
    </div>
  );
};

export default ProgressRing;
